import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowLeft, Smartphone } from 'lucide-react';

export default function WechatPage() {
  const [t] = useTranslation();

  return (
    <div className="tw-w-full">
      {/* 返回登录 */}
      <Link
        to="/user/signin"
        className="tw-flex tw-items-center tw-gap-1 tw-text-sm tw-no-underline tw-mb-5 tw-transition-colors"
        style={{ color: 'rgba(191, 219, 254, 0.6)' }}
        onMouseEnter={(e) => { (e.currentTarget as HTMLElement).style.color = 'rgb(34, 211, 238)'; }}
        onMouseLeave={(e) => { (e.currentTarget as HTMLElement).style.color = 'rgba(191, 219, 254, 0.6)'; }}
      >
        <ArrowLeft className="tw-w-4 tw-h-4" />
        返回登录
      </Link>

      <h3 className="tw-text-lg tw-font-semibold tw-text-white tw-mb-4">
        {t('login.wechat', '微信扫码登录')}
      </h3>

      {/* 二维码区域 */}
      <div className="tw-flex tw-justify-center tw-mb-6">
        <div
          className="tw-w-52 tw-h-52 tw-rounded-xl tw-overflow-hidden tw-flex tw-items-center tw-justify-center"
          style={{
            backgroundColor: 'rgba(255, 255, 255, 0.08)',
            border: '1px solid rgba(255, 255, 255, 0.15)',
          }}
        >
          <img
            src="/images/wechat.jpg"
            alt="WeChat QR Code"
            className="tw-w-48 tw-h-48 tw-object-contain"
          />
        </div>
      </div>

      <p className="tw-text-center tw-text-sm tw-mb-6" style={{ color: 'rgba(191, 219, 254, 0.6)' }}>
        请使用微信扫描二维码登录
      </p>

      {/* 底部链接 */}
      <div className="tw-flex tw-items-center tw-justify-center tw-gap-3">
        <Link
          to="/user/signin"
          className="tw-flex tw-items-center tw-gap-1 tw-text-sm tw-no-underline tw-transition-colors"
          style={{ color: 'rgba(191, 219, 254, 0.6)' }}
          onMouseEnter={(e) => { (e.currentTarget as HTMLElement).style.color = 'rgb(34, 211, 238)'; }}
          onMouseLeave={(e) => { (e.currentTarget as HTMLElement).style.color = 'rgba(191, 219, 254, 0.6)'; }}
        >
          <Smartphone className="tw-w-4 tw-h-4" />
          {t('login.usePhone', '使用手机号')}
        </Link>
        <span style={{ color: 'rgba(191, 219, 254, 0.3)' }}>|</span>
        <Link
          to="/user/signup"
          className="tw-text-sm tw-no-underline tw-transition-colors"
          style={{ color: 'rgba(191, 219, 254, 0.6)' }}
          onMouseEnter={(e) => { (e.target as HTMLElement).style.color = 'rgb(34, 211, 238)'; }}
          onMouseLeave={(e) => { (e.target as HTMLElement).style.color = 'rgba(191, 219, 254, 0.6)'; }}
        >
          {t('auth.signup', '免费注册')}
        </Link>
      </div>
    </div>
  );
}
